import {
  ProductAsset,
  ProductAssetWithRequiredDimensions
} from '@spa/components/ProductAssetTypes';
import { ReactElement, memo } from 'react';
import AssetLinkComponent from '@spa/components/asset-link/asset-link.component';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import styles from './product-energy-label.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';

export interface Props {
  readonly efficiencyClass: ProductAssetWithRequiredDimensions;
  readonly datasheet: ProductAsset | null;
  readonly leftAligned?: boolean;
  readonly overview: ProductAsset | null;
}

function ProductEnergyLabelComponent({
  efficiencyClass,
  datasheet,
  leftAligned,
  overview
}: Props): ReactElement {
  const { formatMessage }: NamespacedIntl = useNamespacedIntl('product-energy-label');
  const { name, source, description, dimensions } = efficiencyClass;
  const labelClass: string = classNames(styles['product-energy-label'], {
    [styles['product-energy-label--left-aligned']]: leftAligned
  });

  const energyLabel: ReactElement = (
    <ImageComponent
      className={styles['product-energy-label__image']}
      src={source}
      alt={name ?? ''}
      title={description ?? ''}
      width={dimensions.width}
      height={dimensions.height}
    />
  );

  return (
    <div className={labelClass}>
      {overview ? (
        <AssetLinkComponent asset={overview} fallbackTitle={formatMessage('overviewFallbackTitle')}>
          {energyLabel}
        </AssetLinkComponent>
      ) : (
        energyLabel
      )}
      {datasheet && (
        <AssetLinkComponent
          asset={datasheet}
          fallbackTitle={formatMessage('datasheetFallbackTitle')}
        >
          <span className={styles['product-energy-label__datasheet']}>
            {formatMessage('datasheetLinkText')}
          </span>
        </AssetLinkComponent>
      )}
    </div>
  );
}

export default memo(ProductEnergyLabelComponent);
